import React from 'react'

// a basic form
const CustomForm = ({ status, message, onValidated }) => {
  let email
  const submit = () =>
    email &&
    email.value.indexOf("@") > -1 &&
    onValidated({
      EMAIL: email.value,
    });

  return (
    <div className="relative inline-block">
      <div className="mb-2">
        <div className="control border-b-2 border-bgmint">
          <input className="inline-block w-[300px] bg-transparent placeholder:text-bgmint text-bgmint text-lg border-0" ref={node => (email = node)} type="email" name="email" placeholder="Enter your email to join our mailing list" />
          <button className="inline-block text-base uppercase bg-transparent text-bgmint leading-none" onClick={submit}>
            Submit
            <svg stroke="currentColor" width="30px" height="20px" viewBox="0 0 10 10" className="inline">
              <path d="M1,5 L11,5" className="fill-none stroke-1 stroke-inherit" />
              <polyline points="8 -1 12 5 8 10" className="fill-none stroke-1" />
            </svg>
          </button>
        </div>
      </div>
      {status === "sending" && (
        <div className='block absolute w-full mx-auto bg-bggreen border-bgmint border-2 p-6 rounded-xl text-xl font-[300] text-bgmint'>
          Sending...
        </div>)}
      {status === "error" && (
        <div className='block absolute w-full mx-auto bg-bggreen border-bgmint border-2 p-6 rounded-xl text-xl font-[300] text-bgmint'
          dangerouslySetInnerHTML={{ __html: message }}
        />
      )}
      {status === "success" && (
        <div className='block absolute w-full mx-auto bg-bggreen border-bgmint border-2 p-6 rounded-xl text-xl font-[300] text-bgmint'
          dangerouslySetInnerHTML={{ __html: message }}
        />
      )}
    </div>
  );
};

export default CustomForm;

